import { useCallback } from 'react';

import type { EditorActions } from '@atlaskit/editor-core/actions';
import type { Provider } from '@atlaskit/collab-provider/provider';
import type { CollabEditProvider, ResolvedEditorState } from '@atlaskit/editor-common/collab';
import type { GetResolvedEditorStateReason } from '@atlaskit/editor-common/types/editor-actions';

type UseGetCollabProviderStateProps = {
	editorActions: EditorActions;
	collabEditProvider: (CollabEditProvider & Provider) | null;
	forceAwaitCommitLocalSteps?: boolean;
	reason: GetResolvedEditorStateReason;
};

export const useGetCollabProviderState = ({
	editorActions,
	collabEditProvider,
	forceAwaitCommitLocalSteps = false,
	reason,
}: UseGetCollabProviderStateProps): ((
	awaitCommitLocalSteps?: boolean,
) => Promise<ResolvedEditorState | undefined> | undefined) => {
	// awaitCommitLocalSteps dictates whether we wait until all the user's local steps are committed to collab-service backend before
	// returning the document, or if we return document immediately
	return useCallback(
		(awaitCommitLocalSteps = true) => {
			return awaitCommitLocalSteps || !!forceAwaitCommitLocalSteps
				? editorActions.getResolvedEditorState(reason)
				: collabEditProvider?.getCurrentState();
		},
		[editorActions, collabEditProvider, forceAwaitCommitLocalSteps, reason],
	);
};
